module.exports = __webpack_public_path__ + "img/logo.dbe3ac38.png";